import React, { useEffect, useRef, useState } from "react";
import Wrapper from "../Components/Wrapper";
import MemoryCountDown from "./MemoryCountDown";
import { useContext } from "react";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import MemoryCard from "./MemoryCard";
import MemoryGameHeading from "./MemoryGameHeading";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";
import MemoryCompleted from "./MemoryCompleted";
import useMediaQuery from "../Hooks/useMediaQuery";
import useIsBottomInView from "../Hooks/useIsFullyInView";


const Memory = () => {

    // const [cards, setCards] = useState([]);
    const [choiceOne, setChoiceOne] = useState();
    const [choiceTwo, setChoiceTwo] = useState();
    const [disabled, setDisabled] = useState(false);

    //*check what cardchoice, first or second?
    const handleChoice = (card) => {
        choiceOne ? setChoiceTwo(card) : setChoiceOne(card);  
    };

    //*check if both card choices is set -> disables other choices
    useEffect(() => {
        if(choiceOne && choiceTwo){
            setDisabled(true);
        }
    }, [choiceOne, choiceTwo]);

    //*resets choices
    const resetChoices = () => {
        setChoiceOne(null);
        setChoiceTwo(null);
    };


    const {levels, cards, handleCards, handleShuffleCards, allCardsMatch, noMatch} = useContext(MemoryLevelContext);
    // useEffect(() => {
    //     handleShuffleCards();
    // }, []);

    //*get height of grid container for cards ========
    const [cardGridHeight, setCardGridHeight] = useState();
    const cardGrid = useRef(null);
    useEffect(() => {
        if(cardGrid.current){
            let height = cardGrid.current.clientHeight;
            setCardGridHeight(height);
        }
    }, [cards]);

    const isSmallScreen = useMediaQuery('(max-width: 480px)');
    const thirdPage = useRef();
    const isInView = useIsBottomInView(thirdPage);

    useEffect(() => {
        setDisabled(false);
        resetChoices();
    }, [cards]);

    //*context variables --> MemoryCountDownContext & MemoryLevelContext
    const stageIsSet = levels.stage.stageIsSet;
    const levelIsSet = levels.level.levelIsSet;
    const {countDownFinished, showCounter, handleShowCounter} = useContext(MemoryCountDownContext);
    const {handleTimer} = useContext(MemoryTimerContext);
    const [openMemory, setOpenMemory] = useState(false);

    
    //*hides countdown when countdown is finsihed 
    useEffect(() => {
        if(countDownFinished){
            setTimeout(() => {handleShowCounter(false)}, 220);
        }
    }, [countDownFinished]);

    //*check if cards matches
    const matchCards = () => {   
         setDisabled(false); // diasble user to pick other cards while choiceOne & choiceTwo is set

        if(choiceOne.cardId === choiceTwo.cardId){
            setDisabled(false); // diasble user to pick other cards while choiceOne & choiceTwo is set
            handleCards(choiceOne);
            resetChoices();
        } else{
            noMatch([choiceOne, choiceTwo]);
            setTimeout(() => {
                // setDisabled(false);
                resetChoices()
            }, 400);
        }
    };

    //show 
    const unmatchCards = () => {
        setDisabled(false);
        resetChoices();
    }

    useEffect(() => {
        if(allCardsMatch){
            handleTimer(false);
        }
    }, [allCardsMatch]);


    useEffect(() => {
        if(stageIsSet && levelIsSet){
            setTimeout(() => {
                setOpenMemory(true);
            }, 20)
        }else{
            setOpenMemory(false);
        }
    }, [stageIsSet]);

    useEffect(() => {
        scrollTo(0,0);
    }, []);

    useEffect(() => {
        if(isSmallScreen){
            document.documentElement.style.setProperty("--wrapper-height", "700px");
        }
    }, [isSmallScreen, openMemory]); 

    return (
        <>
        <div ref={thirdPage} className={`memory-third-page ${openMemory ? "open" : ""}`}>
            {/* Memory game */}
            <Wrapper>
                <MemoryGameHeading/>                
                <div ref={cardGrid} className="card-grid">
                    { cards?.map(card => (
                        <MemoryCard key={card.keyId}
                                    card={card}
                                    handleChoice={handleChoice}
                                    flipped={card === choiceOne || card === choiceTwo || card.matched}
                                    disabled={disabled}
                                    matched={card.matched} 
                        />
                    )) }
                </div>          
                {(!isSmallScreen || isInView) && choiceOne && choiceTwo &&
                    <div className="memory-choice-button-container">
                        <span className="button-container">
                            <button className="button memory-pair-button" onClick={() => matchCards(choiceOne, choiceTwo)}>
                                <span className="label">Para ihop</span> 
                            </button>
                        </span>
                        <span className="button-container">
                            <button className="button button-red memory-pair-button" onClick={() => unmatchCards()}>
                                <span className="label">Para inte ihop</span>
                            </button>
                        </span>
                    </div>
                }                                
            </Wrapper>

            {/* Countdown */}
            {stageIsSet && showCounter && 
                <Wrapper background={"transparent"}>
                    <div className={`countdown-container ${countDownFinished ? "fade-out" : ""}`}>
                        <MemoryCountDown />
                    </div>
                </Wrapper>
            }

            {/* Memory is completed */}
            { allCardsMatch &&
                <MemoryCompleted />
            }           
             

        </div>
        {isSmallScreen && !isInView && choiceOne && choiceTwo &&
            <div className="memory-choice-button-container mobile">
                <span className="button-container">
                    <button className="button memory-pair-button" onClick={() => matchCards(choiceOne, choiceTwo)}>
                        <span className="">Para ihop</span> 
                    </button>
                </span>
                <span className="button-container">
                    <button className="button button-red memory-pair-button" onClick={() => unmatchCards()}>
                        <span className="label">Para inte ihop</span>
                    </button>
                </span>
            </div>
        }
        </>
    );
};

export default Memory;